export default __webpack_public_path__ + "media/src/assets/images/noImg-0700f0a58e9c5dec674f21b8a5830a2b.png";